<template>
    <app-modal size="medium" v-if="hasRole(modalShowVal)">
        <app-modal-content>
            <FormKit
                type="form"
                v-model="values"
                @submit="onSubmit"
                #default="{ value }"
            >
                <app-modal-header
                    :headingText="t('frontend.my-profile-text')"
                />
                <app-modal-body classes="!pt-[3.5rem]">
                    <!-- {{ value }} -->
                    <FormKit
                        :type="profile_image"
                        id="profile_image"
                        name="profile_image"
                        :isProfile="true"
                        folderName="settings/users"
                        :filesData="userFileData"
                        label=""
                        label-class="!block !mb-2 !font-light !text-xs"
                        :uuid="client_portal_url"
                        outer-class="!mb-6"
                    />
                    <p
                        class="font-medium text-black-900 pt-[2.125rem] pb-2.5 border-b mb-6"
                    >
                        Main info
                    </p>
                    <FormKit
                        type="text"
                        id="email"
                        name="email"
                        label="Email"
                        placeholder="Enter user email"
                        readonly="true"
                        outer-class="w-[22.875rem] prefix-repeater-input prefix-suffix-input"
                        validation="required"
                    >
                        <template #prefixIcon>
                            <div class="flex items-center justify-center pl-3">
                                <fa
                                    :icon="['far', 'envelope']"
                                    class="text-gray-300 text-base"
                                ></fa>
                            </div>
                        </template>
                    </FormKit>
                    <FormKit
                            type="text"
                            id="username"
                            name="username"
                            label="Username"
                            validation="required"
                        />
                    <div
                        class="grid grid-cols-3 md:grid-cols-[100px_minmax(230px,_1fr)_230px] gap-4"
                    >
                        <FormKit
                            type="select"
                            name="title"
                            :label="t('frontend.title-text')"
                            :options="['Mr', 'Mrs', 'Mr & Mrs', 'Miss']"
                            :placeholder="t('frontend.title-text')"
                            validation="required"
                            selectIcon="selectIcon"
                            inner-class="!mb-0 !border-none"
                            input-class="!bg-gray-100"
                        />
                        <FormKit
                            type="text"
                            id="firstName"
                            name="firstName"
                            :label="t('frontend.first-name-text')"
                            validation="required"
                        />
                        <FormKit
                            type="text"
                            id="surName"
                            name="surName"
                            label="Last name"
                            validation="required"
                        />
                    </div>
                    <div class="main_info mb-0 max-w-[22.875rem]">
                        <FormKit
                            type="text"
                            name="jobTitle"
                            id="jobTitle"
                            :label="t('frontend.job-title-text')"
                            validation="required"
                        />
                        <FormKit
                            id="phone"
                            name="phone"
                            type="repeater"
                            label="Phone"
                            min="1"
                            max="5"
                            legend-class="!text-xs !font-light !mb-2"
                            content-class="!py-0 !w-full"
                            add-label="+Add phone"
                            add-button-class="addPhoneBtn"
                            item-class="!mb-6 relative"
                            :down-control="false"
                            :up-control="false"
                            removeIcon="removeIcon"
                            :remove-control="removeControl"
                            controls-class="absolute left-full"
                        >
                            <FormKit
                                type="tel"
                                name="mobile"
                                id="mobile"
                                validate="required | tel"
                                outer-class="!mb-0"
                            >
                                <template #prefixIcon>
                                    <FormKit
                                        type="select"
                                        name="phoneType"
                                        :options="['Mobile', 'Office']"
                                        selectIcon="selectIcon"
                                        inner-class="!mb-0 !border-none"
                                        input-class="!bg-gray-100"
                                        selectIcon-class="!ml-[-0.625rem]"
                                        outer-class="!border-r"
                                    />
                                </template>
                                <template #prefix>
                                    <div
                                        class="flex items-center justify-center pl-3"
                                    >
                                        <fa
                                            :icon="['far', 'phone']"
                                            class="text-gray-300 text-base"
                                        ></fa>
                                    </div>
                                </template>
                            </FormKit>
                        </FormKit>
                        <!-- <FormKit
                                type="tel"
                                name="line"
                                id="line"
                                :label="t('frontend.direct-line-text')"
                                prefix-icon="phoneIcon"
                            /> -->
                    </div>

                    <p
                        class="font-medium text-black-900 pt-[2.125rem] pb-2.5 border-b mb-6"
                    >
                        System preference
                    </p>

                    <div class="setting_section_content">
                        <FormKit
                            label="System style"
                            v-model="appearance"
                            type="radio"
                            name="appearance"
                            id="appearance"
                            decorator-icon="radioCheckedIcon"
                            :classes="{
                                options: 'options_inline',
                                'mb-4': true,
                            }"
                            :options="{
                                light: 'Light mode',
                                dark: 'Dark mode',
                            }"
                            validation="required"
                            legend-class="!mb-2 !font-light !text-xs"
                        />
                        <!-- <img
                                class="max-w-[23.125rem] h-auto"
                                src="../../../assets/images/lightdark.png"
                                alt="light and dark mode"
                            /> -->
                    </div>

                    <div class="w-full max-w-[22.875rem] mt-6">
                        <FormKit
                            type="dropdown"
                            name="lang"
                            placeholder="Choose language"
                            :options="languages"
                            selectIcon="selectIcon"
                            inner-class="bg-gray-100 border-none bg-[#F1F5F7]"
                            label="Language"
                            value="en-GB"
                            label-class="!mb-2 !font-light !text-xs"
                        >
                            <template #option="{ option }">
                                <div class="formkit-option">
                                    <img
                                        :src="option.image"
                                        :alt="option.label"
                                    />
                                    <span>
                                        {{ option.label }}
                                    </span>
                                </div>
                            </template>
                        </FormKit>
                        <!-- <pre>{{ value }}</pre> -->
                    </div>
                </app-modal-body>
                <app-modal-footer :isFormkit="true" @onHideModal="toggleModal">
                    <template #formkitButton>
                        <FormKit
                            type="submit"
                            :disabled="saveBtnDisable"
                            label="Save"
                        />
                    </template>
                </app-modal-footer>
            </FormKit>
        </app-modal-content>
    </app-modal>
</template>

<script setup>
// Vue imports
import { computed, ref } from 'vue';

// Components Imports
import AppModal from '@/components/modal/AppModal.vue';
import AppModalBackdrop from '@/components/modal/AppModalBackdrop.vue';
import AppModalBody from '@/components/modal/AppModalBody.vue';
import AppModalContent from '@/components/modal/AppModalContent.vue';
import AppModalDialog from '@/components/modal/AppModalDialog.vue';
import AppModalFooter from '@/components/modal/AppModalFooter.vue';
import AppModalHeader from '@/components/modal/AppModalHeader.vue';
import AppInnerHeading from '@/components/modal/AppInnerHeading.vue';
import { createInput } from '@formkit/vue';
import FilePondPintura from '@/components/imageupload/FilePondPintura.vue';
import FilePondPinturaSingle from '@/components/imageupload/FilePondPinturaSingle.vue';
// Composables Imports
import useToggleModal from '@/composables/useToggleModal';
import { getNode } from '@formkit/core';

// API services imports
import { getUser, updateUserProfile } from '@/api/UserServices';

// Composables imports
import { getUserImage } from '@/composables/globals';
import { useAuthStore } from '@/stores/auth';
import { useTenantStore } from '@/stores/tenant';

// I18n imports
import { useI18n } from 'vue-i18n';
import { useSetErrors } from '@/composables/useSetErrors';
const { formNode, setBackendErrors } = useSetErrors();
import { useThemeSwitcher } from '@/composables/globals';

const { switchTheme } = useThemeSwitcher();
// use global scope
const { t, locale } = useI18n();
// Define emits
const emit = defineEmits(['onSubmission', 'onHideModal']);

// Define props
const props = defineProps({
    modalShowVal: {
        type: String,
        default: '',
        required: true,
    },
});

const profile_image = createInput(FilePondPinturaSingle, {
    props: ['id', 'isProfile', 'filesData', 'folderName', 'uuid'],
});

const branchFileData = ref('');

let saveBtnDisable = ref(false);

const tenantStore = useTenantStore();
const client_portal_url = ref(tenantStore.tenant.client_portal_url);

let userId = ref('');
let userImageFile = ref(null);

const fileUrl = ref('');
const filePond = ref();

const values = ref({});
const appearance = ref('light');

const languages = ref([
    {
        label: 'English - UK',
        value: 'en-GB',
        image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GB.svg',
    },
    {
        label: 'Francais',
        value: 'fr',
        image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FR.svg',
    },
    {
        image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/US.svg',
        label: 'English - US',
        value: 'en-US',
    },
]);

const myFile = (value) => {
    userImageFile.value = value;
};

// Modal composable
const { openModal, hasRole, toggleModal } = useToggleModal();

function onToggleModal(
    role,
    hidden = 'hidden',
    padding = '15px',
    fixed = 'absolute'
) {
    openModal(role, hidden, padding, fixed);
}

const authStore = useAuthStore();

const showModal = async (name) => {
    // Show modal
    await getUserMethod(authStore.authUser.id);
    onToggleModal(name);
};

defineExpose({
    showModal,
});
const userFileData = ref('');
const getUserMethod = async (id) => {
    try {
        const response = await getUser(id);
        console.log(response,'response');
        if (response && response.code === 200) {
            const user = response.data.user;
            userId.value = user.id;

            userFileData.value = getUserImage(user.image_path);
            const phoneData = [];
            for (let i = 1; i <= 5; i++) {
                const phone = user[`phone${i}`];
                const phoneTitle = user[`phone${i}_title`];
                if (phone && phone.trim() !== '' && phoneTitle) {
                    phoneData.push({
                        mobile: phone,
                        phoneType: phoneTitle,
                    });
                }
            }
            const userName = user.user_name;
            const match = userName.match(/^[^@]+/);
            const getUserName = match ? match[0] : null;
            console.log(getUserName,'getUserName')
            values.value = {
                profile_image: userFileData.value,
                title: user.title ? user.title : '',
                username:getUserName,
                firstName: user.first_name ? user.first_name : '',
                surName: user.surname ? user.surname : '',
                email: user.email ? user.email : '',
                jobTitle: user.job_title ? user.job_title : '',
                phone: phoneData ? phoneData : '',
                appearance: user.appearance ? user.appearance : '',
                lang: user.lang ? user.lang : '',
            };
        }
    } catch (e) {
        console.log(e);
    }
};
const userLogoFile = ref({});
// Form submission method
const onSubmit = async () => {
    saveBtnDisable.value = true;
    userLogoFile.value = values.value.profile_image
        ? values.value.profile_image[0]
        : '';
    const phones = values.value.phone;
    let formData = new FormData();
    for (let i = 0; i < phones.length; i++) {
        if (phones[i].mobile && phones[i].mobile.trim() !== '') {
            formData.append(`phone${i + 1}_title`, phones[i].phoneType);
            formData.append(`phone${i + 1}`, phones[i].mobile);
        }
    }
    formData.append('image', userLogoFile.value);
    formData.append('title', values.value.title);
    formData.append('first_name', values.value.firstName);
    formData.append('surname', values.value.surName);
    formData.append('email', values.value.email);
    formData.append('job_title', values.value.jobTitle);
    formData.append('lang', values.value.lang);
    formData.append('appearance', values.value.appearance);
    formData.append('user_name', values.value.username);

    try {
        let response = '';
        response = await updateUserProfile(formData);
        if (response && response.code === 200) {
            if (authStore.authUser.appearance !== values.value.appearance) {
                switchTheme();
            }
            authStore.setAuthUser(response.data.user);
            toggleModal();
            emit('onSubmission');
        } else if (response && response.data.code === 422) {
            if (response.data.data && response.data.data.first_name)
                formNode.value = getNode('firstName');
            setBackendErrors(response.data.data.first_name);
        }
    } catch (e) {
        console.log(e);
    }
    saveBtnDisable.value = false;
};
const removeControl = computed(() => {
    if (values.value.phone.length > 1) {
        return true;
    } else {
        return false;
    }
});

</script>

<style scoped>
:deep(.addPhoneBtn .formkit-input) {
    @apply !bg-transparent !rounded-none !text-dark-100 !p-0 text-sm !h-auto;
}
</style>
